import { useRemoteClientPost } from '../../../../../configs/http-client'
import { CatchMessageError } from '../../../../../remote/catch-message-error'
import { useLocalStorage } from '../../../../../remote/local-storage'
import { useToast } from '../../../../hooks'

export const CashRegisterOpenClose = () => {
  const { getUnitId } = useLocalStorage()
  const { httpClientPost } = useRemoteClientPost('finance')
  const { showToast } = useToast()

  const closeCashRegister = async (idResponsavel?: number, reload?: () => void) => {
    const body: any = {
      idUnidade: getUnitId()
    }

    if (idResponsavel) {
      body.idResponsavel = idResponsavel
    }

    try {
      await httpClientPost('/caixa/fechar', body)
      showToast('Caixa fechado!', 'success')
      if (reload) reload()
    } catch (error) {
      CatchMessageError(error)
    }
  }

  const openCashRegister = async (initialValue: number, idResponsavel?: number, nomeResponsavel?: string) => {
    const body: any = {
      valorInicial: initialValue || 0,
      idUnidade: getUnitId()
    }

    if (idResponsavel) {
      body.idResponsavel = idResponsavel
    }

    if (nomeResponsavel) {
      body.nomeResponsavel = nomeResponsavel
    }

    try {
      await httpClientPost('/caixa/abrir', body)
      showToast('Caixa aberto com sucesso', 'success')
    } catch (error) {
      CatchMessageError(error)
    }
  }

  return {
    closeCashRegister,
    openCashRegister
  }
}
